import Command from "@ckeditor/ckeditor5-core/src/command";
export default class EditWebEmailLinkCommand extends Command {
  execute(data) {
    
  }

  refresh() {
    
  }
}
